<template>
  <div class="value-chain-properties-attr">
    <div class="value-chain-properties-attr__box-item">
                    <ValueChainItem  :title="model.label"
                    :value="model.value"
                    :hint="componentIssues"
                    :persistentHint="componentIssues && componentIssues.length >0"
                    :required="model.isMandatory"
                    :showRequiredSymbol="model.isMandatory"
                    labelCustomStyle="flex:0 0 200px; text-align: left;"
                    :showFieldAsText="model.isReadOnly"
                    dense
                    :color="model.isReadOnly? '#979797': undefined"
                    :valueType="isSwitchType? 'boolean': undefined"
                    :items="isSwitchType && !model.isReadonly? undefined: options"
                    :items-value="isSwitchType? 'value': undefined"
                    :items-text="isSwitchType? 'label': undefined"
                    :rules="attributeRules"
                    :type="fieldType"
                    boxItemClass="align-center"
                    @updateValue="model.value = $event"/>
    </div>
                    <div class="value-chain-properties-attr__transient" v-if="model.transient">
                      <v-tooltip top :color="transientColor" >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="transientColor"
                            v-bind="attrs"
                            v-on="on"
                            class="mr-2 mb-2"
                            style="margin-left: -12px;"
                          >
                          mdi-information-outline
                          </v-icon>
                        </template>
                        <div><strong>{{ $t('ATTRIBUTE_TRANSIENT_LABEL') }}:</strong> 
                          <span style="margin-left: 2px;">
                            <template v-if="!isSwitchType">
                              {{ model.transient }}
                            </template>
                            <template v-else>
                              {{ booleanTransientValue(model.transient) }}
                            </template>
                          </span>
                        </div>
                      </v-tooltip>
                  </div>
  </div>
</template>

<script>
import ValueChainItem from '@/components/item/ValueChainItem.vue';
import {cloneDeep, isEqual} from 'lodash';

  export default {
    name: 'ValueChainPropertiesAttribute',
    components: {ValueChainItem},
    props:{
      attribute: {
        type: Object,
        required: true
      },
      issues: {
        type: Array,
      }
    },
    data(){
      return {
        transientColor: '#1b99a7',
        model: {
          isMandatory: false,
          isReadOnly: true,
          label: '',
          name: '',
          settings: null,
          transient: null,
          type: 'string',
          value: '',
          valueChainName: ''
        }
      }
    },
    created(){
    },
    watch: {
      model:{
        handler(){
            this.$emit('updateModel', cloneDeep(this.model));
        },
        deep: true
      },
      attribute:{
        handler(){
          if(isEqual(this.attribute, this.model))return;
          this.model = cloneDeep(this.attribute);
        },
        deep: true,
        immediate:true
      }
    },
    computed:{
      hint(){
        if(this.model.isMandatory) return this.$i18n.t('VALUE-CHAIN-PROPERTIES-MANDATORY-HINT');
        return '';
      },
      isSwitchType(){
        return this.fieldType === 'switch';
      },
      componentIssues(){
        if(!this.issues) return [];
        const selectedIssues = this.issues.filter((el) => el.attribute && el.attribute.id === this.model.id);
        if(!selectedIssues) return [];
        return selectedIssues.map((el) => el.error).join(',');  
      },
      fieldType(){
        switch(this.model.type){
          case "string": return undefined;
          case 'boolean': return 'switch';
          case 'date': return 'date';
          case 'enum': return undefined;
          default: return 'number';
        }
      },
      booleanTransientValue(){
        return (val) => {
          if(Number(val) === 0) return this.$i18n.t('GLOBAL_FALSE');
          return this.$i18n.t('GLOBAL_FALSE');
        }
      },
      options(){
        if(this.model.type === 'boolean'){
          return  [
                    {value: 1, label: this.$i18n.t('GLOBAL_TRUE')},
                    {value: 0, label: this.$i18n.t('GLOBAL_FALSE')},
                  ];
        }
        if(this.model.type !== 'enum') return undefined;
        if(this.model.settings && this.model.settings.options) return this.model.settings.options;
        return [];
      },
      attributeRules(){
        const rules = [];
        if(!this.model.settings) return rules;
        if(this.model.isReadOnly) return rules;
        if(this.model.isMandatory){
          rules.push(value =>!!value || this.$i18n.t('VALUE-CHAIN-PROPERTY-ATTR-INVALID-REQUIRED'))
        }
        if(this.model.settings.hasOwnProperty('min') && this.model.settings.min !== null){
          if(this.model.type === 'string'){
            rules.push(value => (value || '').length >= this.model.settings.min || this.$i18n.t('VALUE-CHAIN-PROPERTY-ATTR-INVALID-MIN-LENGTH'));
          }else{
            rules.push(value => (value || 0) >= this.model.settings.min || this.$i18n.t('VALUE-CHAIN-PROPERTY-ATTR-INVALID-MIN-AMOUNT'));
          }
        }
        if(this.model.settings.hasOwnProperty('max') && this.model.settings.max !== null){
          if(this.model.type === 'string'){
            rules.push(value => (value || '').length <= this.model.settings.max || this.$i18n.t('VALUE-CHAIN-PROPERTY-ATTR-INVALID-MAX-LENGTH'));
          }else{
            rules.push(value => (value || 0) <= this.model.settings.max || this.$i18n.t('VALUE-CHAIN-PROPERTY-ATTR-INVALID-MAX-AMOUNT'));
          }
        }
        if(this.model.settings.hasOwnProperty('pattern') && this.model.settings.pattern !== null){
          if(this.model.type === 'string'){
            rules.push(value => {
              const regularExprCheck = new RegExp(this.model.settings.pattern);
              if(regularExprCheck.test(value)) return true;
              return this.$i18n.t('VALUE-CHAIN-PROPERTY-ATTR-INVALID-PATTERN');
            });
          }
        }
        if(this.model.type === 'integer'){
          rules.push(value => {
            if((new RegExp("^[0-9]+$")).test(value) || value === null) return true;
            return this.$i18n.t('VALUE-CHAIN-PROPERTY-ATTR-INVALID-INTEGER');
          });
        }
        return rules;
      },
    },
    methods:{

    }
    
  }
</script>

<style lang="scss" scoped>
.value-chain-properties-attr{
  display: flex;
  margin-top: .2em;
  &__box-item{
    flex: 0 0 450px;
    display:flex;
    align-items: center;
  }
  &__transient{
    flex: 0 0 30px;
    display: flex;
    align-items: center;

    position: relative;
  }
}
</style>
